/* (ignored) */


//////////////////
// WEBPACK FOOTER
// buffer (ignored)
// module id = 922
// module chunks = 2